import { ApiNames, ApiProxy, ApiRequest } from '@lib/api/apiProxy';

export class PayrollToCastingQueryApi {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.PayrollToCasting;

  public static getPayrollWorkLocations(
    castingProjectId: number,
  ): Promise<PayrollWorkLocation[]> {
    const endpoint = `/workLocations/${castingProjectId}`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static checkIfPayrollProjectHasBookings(
    castingProjectId: number,
    unitNames?: string,
    startDate?: string,
    endDate?: string,
  ): Promise<PayrollProjectHasBookingsResponse> {
    let endpoint = `/checkPayrollProjectHasBookings/${castingProjectId}`;
    const queryParams = {};
    if (unitNames) queryParams['unit_names'] = unitNames;
    if (startDate) queryParams['start_date'] = startDate;
    if (endDate) queryParams['end_date'] = endDate;

    const queryString = Object.keys(queryParams)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
      .join('&');
    if (queryString) {
      endpoint += `?${queryString}`;
    }
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static getDisplayI9Indicators(
    castingProjectId: number,
  ): Promise<DisplayI9Indicators> {
    const endpoint = `/displayI9Indicators/${castingProjectId}`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }
}
